import React from "react";
import PropTypes from "prop-types";
import i18n from "micro-i18n";
import { IconFlag } from "components/icons/Icons";
import { JotType } from "consts";
import { connect } from "unistore/preact";
import { actions } from "actions";
import { getDeckState, isNullOrUndefOrEmpty, toObject } from "utils";
import classNames from "classnames";

const ReportModalButton = ({
  onToggleModal,
  widgetState,
  questionsData = {},
  questionIndex,
  showModal = false,
  modalId,
  className,
  focusRef,
  jot,
}) => {
  if (isNullOrUndefOrEmpty(onToggleModal) || isNullOrUndefOrEmpty(modalId) || isNullOrUndefOrEmpty(focusRef)) {
    return null;
  }

  const { currentQuestion } = getDeckState({
    widgetState,
    questionsData,
    questionIndex,
  });

  const { isReportable = false } = toObject(currentQuestion);

  const handleToggleReportModal = () => {
    jot({ space: "poll", type: JotType.ReportClick, question: currentQuestion });
    onToggleModal();
  };

  return isReportable ? (
    <button
      role="button"
      type="button"
      ref={focusRef}
      onClick={handleToggleReportModal}
      className={classNames("csw-btn csw-report-modal-btn outline", className)}
      aria-expanded={showModal}
      aria-haspopup="true"
      aria-controls={modalId}
      title={i18n.t("BUTTON_FEEDBACK")}
      aria-label={i18n.t("BUTTON_FEEDBACK")}
    >
      <span className="csw-btn-txt">{i18n.t("BUTTON_FEEDBACK_TEXT")}</span>
      <IconFlag />
    </button>
  ) : null;
};

ReportModalButton.propTypes = {
  onToggleModal: PropTypes.func.isRequired,
  widgetState: PropTypes.number,
  questionsData: PropTypes.object,
  questionIndex: PropTypes.number,
  showModal: PropTypes.bool,
  modalId: PropTypes.string.isRequired,
  className: PropTypes.string,
  focusRef: PropTypes.object.isRequired,
  jot: PropTypes.func,
};

export default connect("widgetState,questionsData,questionIndex", actions)(ReportModalButton);
